
import { Info } from 'lucide-react';

const DemoDisclaimer = () => {
  return (
    <div className="bg-white p-4 rounded-lg border border-border shadow-sm">
      <div className="flex items-start gap-2">
        <Info className="h-5 w-5 text-primary flex-shrink-0 mt-0.5" />
        <div>
          <h3 className="text-sm font-medium mb-1">Interactive Mockup</h3>
          <p className="text-xs text-neutral-600">
            This is a demonstration of our planned workflow builder interface. 
            In the actual product, you'll be able to create and run real Bayesian 
            analysis workflows by connecting nodes and configuring parameters.
          </p>
        </div>
      </div>
    </div>
  );
};

export default DemoDisclaimer;
